import { BabyBuggyIcon } from './BabyBuggyIcon';

/**
 * author: Moma Design Studio
 * id 46AF3844-1F3F-43B5-A93B-424EC83BCADB
 * name baby-buggy
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/baby-buggy.svg
 * tags
 * - People / Family 
 */
export const StrollerIcon = BabyBuggyIcon;
export default StrollerIcon